<div class="flex flex-col justify-between h-[9rem] overflow-hidden" [class]="direction">
  <!--
    a11y: top close (X) added so the popup satisfies the audit requirement
    (every popup must expose a close button at the top + receive initial
    focus there). Marked with [focusInitial]=true.
  -->
  <div class="!flex justify-end">
    <mot-button matType="icon" icon="close"
      [ariaLabel]="closeText"
      class="!border-none !w-min !h-min cursor-pointer !bg-transparent" iconClass="!text-2xl"
      [focusInitial]="true"
      (onClick)="closeCard()" />
  </div>

  <p class="text-center break-words px-2">{{cantFindLocationText}}</p>
  @if (isDesktop) {
    <div class="!flex justify-end !sticky bottom-2 px-2">
      <mot-button [text]="closeText"
        buttonClass="!bg-primary !w-4 !text-white !px-2 !py-3 !rounded-lg !align-middle mt-0.5"
        (onClick)="closeCard()" />
      </div>
    }
  </div>
